interface ToggleCardProps {
  title: string;
  consequence?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
}

/** Hele kaart is het raakvlak (≥ 56 px); de schakelaar is beeld, geen los knopje. */
export function ToggleCard({ title, consequence, checked, onChange }: ToggleCardProps) {
  return (
    <button
      type="button"
      className="togglecard"
      aria-pressed={checked}
      onClick={() => onChange(!checked)}
    >
      <span>
        <span className="togglecard__title">{title}</span>
        {consequence ? <span className="togglecard__consequence">{consequence}</span> : null}
      </span>
      <span className="toggle" aria-hidden>
        <span className="toggle__knob" />
      </span>
    </button>
  );
}
